import { makeStyles } from '@material-ui/core';

import { neutral, red, yellow } from '../../shared/styles/colors';

export default makeStyles(theme => ({
  chipsContainer: {
    width: '100%',
    padding: '0.5rem 0',
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  deliverToUserButton: {
    height: 'stretch',
    width: 'min-content',
    maxWidth: 'fit-content',
    padding: '0.25rem 0.5rem',
    fontSize: '0.75rem',
    lineHeight: '1rem',
    fontFamily: 'Poppins',
    borderRadius: '0.5rem',
    color: neutral.white,
    backgroundColor: yellow['50'],
    '&:hover': { backgroundColor: yellow['50'] },
    '@media (width >= 960px)': {
      width: 'fit-content',
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
    },
  },
  root: {
    display: 'flex',
    flexGrow: 1,
    height: '100vh',
    overflow: 'hidden',
    position: 'relative',
    zIndex: 1,
    '@media print': {
      display: 'none',
    },
  },
  showFiltersButton: {
    borderRadius: '50px',
    fontFamily: 'Poppins',
    fontSize: '13px !important',
    marginLeft: '16px',
    maxWidth: '117px',
    padding: '10px 12px',
  },
  appBarRoot: {
    backgroundColor: red['50'],
    boxShadow: 'none',
    height: 32,
    zIndex: theme.zIndex.drawer + 1,
  },
  content: {
    backgroundColor: neutral['20'],
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  toolbarTitleContainer: {
    padding: '0 0 0 0.25rem',
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
    lineHeight: 0,
    [theme.breakpoints.up('md')]: {
      padding: '0 0 0 0.75rem',
    },
  },
  mobileToolbarRoot: () => ({
    minHeight: 'auto',
    paddingRight: '0.25rem',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: neutral.white,
    borderBottom: `1px solid ${neutral['20']}`,
    [theme.breakpoints.up('md')]: {
      paddingRight: '1.4rem',
    },
  }),
  notificationsIconButton: {
    padding: 0,
  },
  sectionHeader: {
    backgroundColor: neutral.white,
    boxShadow: `0 1px 0 0 ${neutral['20']}`,
    minHeight: 64,
    position: 'relative',
  },
  sectionContent: {
    backgroundColor: neutral[10],
    flex: '0 1 100%',
    overflow: 'auto',
  },
  containerLogo: {
    display: 'none',
    cursor: 'pointer',
    '@media (width >= 520px)': {
      display: 'block',
    },
    '& img': {
      minWidth: '2.5rem',
      maxWidth: '4.125rem',
      '@media (width >= 768px)': {
        maxWidth: 'min-content',
      },
    },
  },
  storeInfo: {
    color: neutral['90'],
    fontFamily: 'Poppins',
    fontSize: '20px',
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 'bold',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    margin: 'auto 24px',
  },
  toolbarButtons: {
    marginLeft: 'auto',
  },
  avatar: {
    height: '34px',
    margin: '10px 24px 10px 10px',
    width: '34px',
  },
  footer: {
    padding: '0.5rem 0.75rem',
    display: 'flex',
    gap: '0.5rem',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    backgroundColor: neutral['10'],
  },
  footerOurFns: {
    display: 'flex',
    gap: '0.5rem',
  },
  footerSWC: {
    display: 'flex',
    gap: '0.25rem',
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& > label': {
      display: 'none',
      fontWeight: 600,
      fontSize: '0.875rem',
      lineHeight: '1.5rem',
      color: neutral['60'],
      '@media (width >= 520px)': {
        display: 'block',
      },
    },
    '& > button': {
      padding: '0.5rem 0.75rem',
      fontFamily: 'Poppins',
      lineHeight: '1.5rem',
      fontWeight: 600,
      zIndex: 10,
      // pointerEvents: 'none',
      border: `1px solid ${neutral['20']}`,
      borderRadius: '0.5rem',
      color: neutral['100'],
      backgroundColor: neutral.white,
      '& .MuiButton-startIcon': {
        marginLeft: 0,
        marginRight: '0.25rem',
      },
    },
    // the attribute data-testid is into WebChat component, this is external
    '& > support-web-chat': {
      marginLeft: '-0.25rem',
    },
    // the attribute data-testid is into WebChat component, this is external
    '& > support-web-chat > main[data-testid="mainPlugChat"]:first-child > button': {
      width: '6rem',
      right: '7.875rem',
    },
    // the attribute data-testid is into WebChat component, this is external
    '& > support-web-chat > main[data-testid="mainPlugChat"]:last-child > button': {
      width: '6.5rem',
      right: '1.0rem',
    },
    // the attribute data-testid is into WebChat component, this is external
    '& > support-web-chat > main[data-testid="mainPlugChat"] > button:first-of-type': {
      height: '2.625rem',
      bottom: '0.5rem',
      zIndex: 20,
      border: 'none',
      boxShadow: 'none',
      backgroundColor: 'transparent',
      '& > *:not(span)': {
        display: 'none',
      },
    },
    // the attribute data-testid is into WebChat component, this is external
    '& > support-web-chat > main[data-testid="mainPlugChat"] div[data-testid="welcome-message"]': {
      content: 'please support-web-chat hide when it is not needed',
      display: 'none',
    },
  },
}));
